// Zoneless aliases (fast functions that are not patched by Zone.js)
const w: any = window
export const setTimeoutNoZone: typeof setTimeout = w.__zone_symbol__setTimeout
export const setIntervalNoZone: typeof setInterval = w.__zone_symbol__setInterval
export const mutationObserverNoZone: typeof MutationObserver = w.__zone_symbol__MutationObserver
export const promiseNoZone: typeof Promise = w.__zone_symbol__Promise
export const fetchNoZone: typeof fetch = w.__zone_symbol__fetch
export const addEventListenerNoZone = w.__zone_symbol__addEventListener
